import styled from 'styled-components';
import { darkGreen, lightGray, white } from '../../../styles/Variables';

export const RangeSliderWrapper = styled.div`
    width: 100%;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
`;

export const Slider = styled.div`
    position: relative;
    width: 100%;
    border-radius: 15px;
    height: 30px;
`;

export const SliderTrack = styled(Slider)`
    position: absolute;
    background-color: #ced4da;
    width: 100%;
    z-index: 1;
`;

export const SliderRange = styled(Slider)`
    position: absolute;
    background: -webkit-linear-gradient(top, #94d232 0%, #8bba2b 100%);
    z-index: 2;
`;

export const Thumb = styled.input`
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
    pointer-events: none;
    position: absolute;
    height: 0;
    width: calc(100% - 35px);
    outline: none;

    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        -webkit-tap-highlight-color: transparent;
        background-color: #f1f5f7;
        border: none;
        border-radius: 50%;
        box-shadow: 0 0 1px 1px #ced4da;
        cursor: pointer;
        height: 35px;
        width: 35px;
        margin-top: 29px;
        pointer-events: all;
        position: relative;
    }

    &::-moz-range-thumb {
        background-color: #f1f5f7;
        border: none;
        border-radius: 50%;
        box-shadow: 0 0 1px 1px #ced4da;
        cursor: pointer;
        height: 35px;
        width: 35px;
        margin-top: 29px;
        pointer-events: all;
        position: relative;
    }
`;

export const LeftThumb = styled(Thumb)`
    z-index: 3;
`;

export const RightThumb = styled(Thumb)`
    z-index: 4;
`;

export const SliderValue = styled.div`
    color: ${darkGreen};
    font-size: 0.875rem;
    font-weight: 700;
    margin-top: 20px;
    position: absolute;
`;

export const SliderLeftValue = styled(SliderValue)`
    top: 15px;
    left: 6px;
`;

export const SliderRightValue = styled(SliderValue)`
    top: 15px;
    right: -2px;
`;

export const SearchButton = styled.div`
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.875rem;
    border: 1px solid ${lightGray};
    padding: 0.75em 1.875em;
    border-radius: 5px;
    cursor: pointer;
    background: -webkit-linear-gradient(top, #94d232 0%, #8bba2b 100%);
    color: ${white};
    text-align: center;
    margin-top: 2rem;
    min-width: 6rem;
    align-self: center;
`;
